import TimesheetStatus from "@/models/Timesheets/TimesheetStatus";

export default class TimesheetSearchRequest {
    status: TimesheetStatus;
    startAtFrom: string;
    startAtTo: string;
    companyId: string;
    locationId: string;
    workerId: string;
    branchId: string;
    deskId: string;
}